/** The identity fold (NFKC + lowercase) — defined once, server-safe, in
 *  `shared/text/fold`; re-exported so client imports stay unchanged. */
export { fold } from '../../text/fold.js';

/** An optionally signed plain decimal: '12', '-3', '2.5', '.5', '4.'. */
const PLAIN_DECIMAL = /^[+-]?(\d+\.?\d*|\.\d+)$/;

/** A typed figure as a number, read through the same NFKC fold — so a
 *  full-width '１２' counts as 12. Blank reads as 0, as `Number` does; callers
 *  decide what is valid. Only a plain decimal is a figure: `Number` alone also
 *  reads '0x10' as 16, '1e3' as 1000 and 'Infinity' as a number, none of which
 *  anyone on site means — those read as NaN. */
export const parseNumber = (text: string): number => {
  const value = text.normalize('NFKC').trim();
  if (value === '') return 0;
  return PLAIN_DECIMAL.test(value) ? Number(value) : NaN;
};
